import { formatSecretName } from "@repo/app-types/entities/secret";

/**
 * Formats a name as it is typed into the focused input, keeping the caret
 * where the user put it. Call it from the input's change handler.
 *
 * React moves the caret to the end when it writes a value that differs from
 * the one typed, so the formatted name is written back here first, and React
 * then finds nothing to change. The formatting keeps the length of ASCII text,
 * so the caret's index still fits.
 */
export function formatTypedSecretName(text: string): string {
  const formatted = formatSecretName(text);
  const input = document.activeElement;
  if (
    formatted !== text &&
    input instanceof HTMLInputElement &&
    input.value === text
  ) {
    const { selectionStart, selectionEnd } = input;
    input.value = formatted;
    input.setSelectionRange(selectionStart, selectionEnd);
  }
  return formatted;
}
